"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@report/fund/success",
  ERROR: "@@report/fund/error",
  FIND_FUND: "@@report/fund/list-by-id-year",
  FIND_DETAILS: "@@report/fund/list-by-id-year",
  FIND_CURRENT_FISCAL: "@@report/fund/find-current-fiscal",
  REPORT_DATA: "@@report/fund/report-data",
  LIST: "@@report/fund/list",
  CRITERIA_LIST: "@@report/fund/criteria-list",
  CREATE: "@@report/fund/create",
  UPDATE: "@@report/fund/update",
  DELETE: "@@report/fund/delete",
  TYPE_LIST: "@@report/fund/type-list",
  YEAR_LIST: "@@report/fund/year",
  CHECK_UNIQUE: "@@report/fund/check-unique",
  CHECK_UNIQUE_RESET: "@@report/fund/check-unique-reset",
  DELETE_ALL: "@@report/fund/delete-all",
  RESET: "@@report/fund/reset",
  SOFT_DELETE: "@@report/fund/soft-delete",
  RESTORE_SOFT_DELETE: "@@report/fund/restore-soft-delete",
  LIST_RESTORE_SOFT_DELETE: "@@report/fund/list-restore-soft-delete"
};
exports.actionTypes = actionTypes;